<template>
  <div>
    <v-layout wrap class="mb-4">
      <v-flex xs9>
        <h3 class="headline mt-1 ml-2">
          <img src="/static/img/scgexpress.png" alt style="max-height: 50px" />
        </h3>
      </v-flex>
      <v-flex xs3 class="text-xs-right">
        <v-btn fab outline small color="primary" v-if="!isEdit" @click="onClickIsEdit">
          <v-icon>edit</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div v-else>
      <v-stepper v-model="step" vertical class="elevation-0">
        <v-stepper-step step="1" :complete="step > 1">
          {{ $t('register_scg_express') }}
        </v-stepper-step>
        <v-stepper-content step="1">
          <div>{{ $t('connect_scg_express_service_for_more') }}</div>
          <v-btn
            depressed
            color="primary"
            :href="'https://www.scgexpress.co.th/scgexpressclub/#'"
            target="_blank"
            @click="step = 2"
            >{{ $t('register_scg_express') }}</v-btn
          >

          <v-btn flat @click="step = 2">
            {{ $t('already_have_an_account') }}
          </v-btn>
          <div>
            <a href="https://blog.zwiz.app/zwizai-x-scgexpress/" target="_blank"
              >{{ $t('how_to_use_scg_express') }}</a
            >
          </div>
        </v-stepper-content>

        <v-stepper-step step="2" :complete="step > 2">
          {{ $t('connect_zwiz_with_scg_express') }}
        </v-stepper-step>

        <v-stepper-content step="2">
          <div
            class="pa-2"
            style="position: relative; "
          >
            <div class="caption">
              {{ $t('confirmation_from_scg_express') }}
            </div>
            <form>
              <v-layout wrap>
                <v-flex xs12 sm6 class="pa-1">
                  <div class="caption">Username</div>
                  <div
                    class="form-control"
                    :class="{ 'has-error': errors.has('scg_username') }"
                    v-if="isEdit"
                  >
                    <input
                      class="form-control"
                      type="text"
                      v-model="setting.scg_username"
                      v-validate="'required'"
                      name="scg_username"
                      data-vv-as="Username"
                      maxlength="255"
                    />
                    <span class="text-error" v-if="errors.has('scg_username')">{{
                      errors.first('scg_username')
                    }}</span>
                  </div>
                  <div class="primary--text" v-else>
                    {{ setting.scg_username ? setting.scg_username : '-' }}
                  </div>
                </v-flex>
                <v-flex xs12 sm6 class="pa-1" v-if="isEdit">
                  <div class="caption">Password</div>
                  <div class="form-control" :class="{ 'has-error': errors.has('scg_password') }">
                    <input
                      class="form-control"
                      type="password"
                      v-model="setting.scg_password"
                      v-validate="'required'"
                      name="scg_password"
                      data-vv-as="Password"
                      maxlength="255"
                    />
                    <span class="text-error" v-if="errors.has('scg_password')">{{
                      errors.first('scg_password')
                    }}</span>
                  </div>
                </v-flex>
              </v-layout>
            </form>
            <div class="mb-2">
              <div>
                {{ $t('enable_disable_scg_express') }}
              </div>
              <div>
                <toggle-button
                  class="mt-2"
                  :value="setting.is_active"
                  :sync="true"
                  :color="$vuetify.theme.success"
                  @change="toggleStatus"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  style="display: inline-block"
                />
              </div>
            </div>
            <div class="text-xs-center" v-if="isEdit">
              <v-btn
                color="grey"
                outline
                @click="
                  step = 1
                  isEdit = false
                "
                v-if="showCancel"
                :loading="loading"
              >
                {{ $t('Back') }}
              </v-btn>
              <v-btn color="primary" depressed @click="onSave" :loading="loading">
                {{ $t('Save') }}
              </v-btn>
            </div>
          </div>
        </v-stepper-content>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  components: {
    ToggleButton
  },
  data() {
    return {
      charge: [],
      showAdvanced: true,
      isEdit: false,
      loading: false,
      zortoutToken: null,
      setting: {},
      showCancel: true,
      step: 1
    }
  },
  async mounted() {
    const vm = this
    vm.getScgExpressConfig()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  methods: {
    onClickIsEdit() {
      const vm = this
      vm.isEdit = !vm.isEdit
      vm.setting.scg_password = ''
    },
    async getScgExpressConfig() {
      const vm = this
      const data = {
        pageId: vm.selectedBot.pageid
      }
      let response = await vm.get(`scg-express/${data.pageId}/config`)
      if (response.success) {
        vm.setting = response.result
        if (vm.setting.is_active) {
          vm.step = 2
        }
      }
    },
    async putScgExpressConfig() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const data = {
          pageId: vm.selectedBot.pageid,
          body: vm.setting
        }
        let response = await vm.put(`scg-express/${data.pageId}/config`, data.body)
        if (!response.success) {
          vm.$swal.fire({
            title: vm.$t('Unsuccessful'),
            type: 'error'
          })
        }
        vm.$store.dispatch('loading')
        return response
      } catch (error) {
        vm.$swal.fire({
          title: vm.$t('Unsuccessful'),
          type: 'error'
        })
      }
    },
    async onSave() {
      const vm = this
      let isValid = await vm.$validator.validateAll()
      if (isValid) {
        let response = await vm.putScgExpressConfig()
        if (response.success) {
          await vm.$swal.fire({
            title: vm.$t('Successfully'),
            type: 'success'
          })
          vm.isEdit = false
        }
      }
    },
    async toggleStatus() {
      const vm = this
      vm.setting.is_active = !vm.setting.is_active
      let response = await vm.putScgExpressConfig()
      if (!response.success) {
        vm.setting.is_active = !vm.setting.is_active
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ScgManage.vue